<app-auth-shell panelClass="max-w-[980px]">
  <div class="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr]">
    <section class="border-b border-textbox-border p-6 sm:p-8 lg:border-b-0 lg:border-r lg:p-10">
      <div class="mb-8">
        <div
          class="mb-3 inline-flex rounded-full border border-periwinkle-border bg-periwinkle-soft px-3 py-1 inter-500 text-[12px] text-periwinkle"
        >
          Welcome back
        </div>
        <h1
          class="font-spaceGrotesk text-[32px] font-semibold leading-tight text-inverted-neutral sm:text-[40px]"
        >
          Sign in
        </h1>
        <p class="mt-3 max-w-md inter-300 text-[15px] leading-6 text-support-text">
          Continue to your Kekeno Surveys workspace.
        </p>
      </div>

      <div class="flex flex-col">
        @if (!twoFactor) {
          <input
            [formControl]="loginForm.controls.email"
            class="form-control mb-4"
            placeholder="Email"
            type="text"
          />
        }
        @if (!twoFactor) {
          <input
            [formControl]="loginForm.controls.password"
            class="form-control"
            placeholder="Password"
            type="password"
          />
          <div class="mb-8 mt-2 flex justify-end">
            <button
              type="button"
              (click)="forgotPassword()"
              class="font-spaceGrotesk text-sm text-support-text transition-colors hover:text-kek-purple"
            >
              Forgot password?
            </button>
          </div>
        }
        @if (twoFactor) {
          <input
            [formControl]="loginForm.controls.twoFactorCode"
            class="form-control mb-8"
            placeholder="2FA Code"
            type="text"
          />
        }

        <div class="flex justify-start">
          @if (loading()) {
            <span class="loading loading-spinner loading-md"></span>
          } @else {
            <button
              (click)="login()"
              matRipple
              class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[16px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
            >
              Log In
            </button>
          }
        </div>
      </div>
    </section>

    <aside class="bg-surface-cool p-6 sm:p-8 lg:p-10">
      <div class="mb-8">
        <div
          class="mb-3 inline-flex rounded-full border border-companion-teal-border bg-companion-teal-soft px-3 py-1 inter-500 text-[12px] text-companion-teal"
        >
          New workspace
        </div>
        <h2
          class="font-spaceGrotesk text-[26px] font-semibold leading-tight text-inverted-neutral sm:text-[32px]"
        >
          Create an account
        </h2>
        <p class="mt-3 inter-300 text-[15px] leading-6 text-support-text">
          Start a workspace for personal projects or your organisation.
        </p>
      </div>

      <div class="flex flex-col">
        <input
          [formControl]="registerForm.controls.firstName"
          class="form-control mb-4"
          placeholder="First name"
          type="text"
        />
        <input
          [formControl]="registerForm.controls.email"
          class="form-control mb-8"
          placeholder="Email address"
          type="text"
        />
        <div class="flex justify-start">
          <button
            (click)="register()"
            matRipple
            class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[16px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none"
          >
            Sign Up
          </button>
        </div>
      </div>
    </aside>
  </div>
</app-auth-shell>
